/**
 * DEMO PLACEHOLDERS - Remove when real data available from backend.
 * All values below are for demo presentation only and should be replaced
 * with actual API data when those endpoints/fields exist.
 */
export const DEMO_PLACEHOLDERS = {
  // PLACEHOLDER: Company/Category/Industry not in Customer model
  companyName: 'BrightCare Medical Group',
  category: 'Corporate Catering',
  industry: 'Healthcare',

  // PLACEHOLDER: No customer scoring logic exists
  customerScore: 91,

  // PLACEHOLDER: CLV differs from total_spent in screenshot; use placeholder until defined
  customerLifetimeValue: 124800,

  // PLACEHOLDER: Monthly revenue aggregation - no backend endpoint
  revenueTrendData: [
    { month: 'Jan', revenue: 5000 },
    { month: 'Feb', revenue: 5800 },
    { month: 'Mar', revenue: 6200 },
    { month: 'Apr', revenue: 7100 },
    { month: 'May', revenue: 7800 },
    { month: 'Jun', revenue: 8500 },
  ],
  revenueTrendVsLastYear: 8,

  // PLACEHOLDER: Meal period from orders - OrderListSerializer excludes meal_type; add for real data
  mealPeriodBreakdown: [
    { period: 'Lunch', value: 72 },
    { period: 'Breakfast', value: 18 },
    { period: 'Dinner', value: 10 },
  ],

  // PLACEHOLDER: No backend calculation for these metrics
  avgDaysBetweenOrders: 5.6,
  repeatProbability: 94,

  // PLACEHOLDER: Corporate account flag not in Customer model
  isCorporateAccount: true,
};
